<template>
  <div class="app-wrapper">
    <div class="top-nav">
      <div class="logo">
        <img src="@/assets/images/logo.png" alt="">
      </div>
      <div class="ml20 nav">
        <el-button type="text" @click="dialogVisibleAI = true" style="float: left;">AI智能检索</el-button>
        <el-button type="text" @click="dialogVisible = true">修改密码</el-button>
        <span class="mr10 ml40">
          当前登录：{{ userInfo.userName }}
        </span>
        <el-button type="text" @click="clearData">退出</el-button>
      </div>
    </div>
    <!--修改密码弹窗-->
    <EDialog :dialogVisible="dialogVisible" title="修改密码" @handleClose="cancelDialog" width="30%"
      @handleClick="editPassword">
      <EForm :formColumns="formColumns" :rowSize="1" :optionsBtn="false" :actionBtn="true" :formData="form" ref="form"
        :searchFlag="false" :formRules="formRules">
      </EForm>
    </EDialog>

    <el-dialog title="AI智能检索" :visible.sync="dialogVisibleAI">
      <div class="doubao-chat-container">
        <!-- 对话内容区域 -->
        <div class="chat-content" ref="chatContent" id="chat-content">
          <!-- 系统欢迎消息 -->
          <div class="message-item system">
            <div class="avatar">🤖</div>
            <div class="content">你好！我是智能小助手，有什么可以帮助你的？</div>
          </div>

          <!-- 用户消息列表 -->
          <div class="message-item" :class="{ user: item.role === 'user', assistant: item.role === 'assistant' }"
            v-for="(item, index) in messageList" :key="index">
            <div class="avatar">{{ item.role === 'user' ? '👤' : '🤖' }}</div>
            <div class="content">
              <span>{{ item.content }}</span>
            </div>
          </div>

          <!-- 加载中状态 -->
          <div class="message-item assistant loading" v-if="loading">
            <div class="avatar">🤖</div>
            <div class="content">
              <span>正在思考...</span>
              <span class="loading-dot">●</span>
              <span class="loading-dot">●</span>
              <span class="loading-dot">●</span>
            </div>
          </div>
        </div>


      </div>
      <div slot="footer" class="dialog-footer">
        <!-- 消息输入区域 -->
        <div class="chat-input">
          <textarea v-model="inputMessage" placeholder="请输入你想提问的内容..." @keyup.enter="handleSendMessage"
            class="input-area"></textarea>
          <button class="send-btn" @click="handleSendMessage" :disabled="!inputMessage || loading">
            发送
          </button>
        </div>
      </div>
    </el-dialog>

    <router-view />
  </div>
</template>

<script>
import SideBar from '@/components/SideBar'
import userInfo from '@/components/userInfo'
import TopBar from '@/components/TopBar'
import toDoDialog from '@/components/toDoDialog'
import EDialog from '@/components/EDialog'
import EForm from '@/components/EForm'
import Http from '@/service/http'
import vxRule from "@/assets/js/formValidate";
import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      dialogVisible: false,
      form: {
        oldPassword: '',
        newPassword: '',
        newPassword1: '',

      },
      formColumns: [
        {
          title: '原始密码',
          type: 'password',
          property: 'oldPassword',
          show: true,
        },
        {
          title: '新密码',
          type: 'password',
          property: 'newPassword',
          show: true,
        },
        {
          title: '确认密码',
          type: 'password',
          property: 'newPassword1',
          show: true,
        },
        {
          type: 'actionBtn',
          show: false
        }
      ],
      formRules: {
        oldPassword: vxRule(true, '', "blur", "原始密码不能为空"),
        newPassword: [vxRule(true, '', "blur", "新密码不能为空"),
        vxRule(true, val => {
          if (val.length < 8 || val.length > 24) {
            return { errMsg: "密码必须为8-24个字符" }
          } else {
            const regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[\W_]).{8,24}$/;
            if (!regex.test(val)) {
              return { errMsg: "密码必须为8-24位字母,数字和符号" }
            }

          }

        })
        ],
        newPassword1: [vxRule(true, '', "blur", "确认密码不能为空"),
        vxRule(true, val => {
          return { result: val === this.form.newPassword, errMsg: "确认密码与新密码不一致" }
        })],
      },
      dialogVisibleAI: false,
      messageList: [],
      inputMessage: '',
      loading: false
    }
  },
  components: {
    SideBar,
    userInfo,
    TopBar,
    toDoDialog,
    EDialog,
    EForm
  },
  computed: {
    ...mapGetters(['userInfo']),
    matched() {
      return this.$route.matched
    }
  },
  methods: {
    ...mapActions(['setTips', 'setMenu', 'setUserInfo', 'setButton', 'setDisabled']),
    handleClick({ name, type }) {
      this.$router.push({ name, query: { type } })
    },
    openDialog() {
      this.getData()
    },
    clearData() {
      this.$router.replace({ path: '/login' })
      this.setUserInfo({})
      this.setMenu([])
      this.setButton([])
      this.setDisabled(false)
    },
    async editPassword() {
      let res = await Http.updatePassword(this.form)
      if (res.code == 200) {
        this.$message.success('修改成功，请重新登录')
        this.clearData()
        this.cancelDialog()
      }
    },
    cancelDialog() {
      this.dialogVisible = false
      this.form = {
        oldPassword: '',
        newPassword: '',
        newPassword1: '',

      }
    },
    cancelDialogAI() {
      this.dialogVisibleAI = false
    },
    // 发送消息
    async handleSendMessage(){
      let that = this
      const message = that.inputMessage;
      if (!message || that.loading) return;

      // 添加用户消息
      that.messageList.push({
        role: 'user',
        content: message
      });

      // 清空输入框，开始加载
      that.inputMessage = '';
      that.loading = true;

      try {
        // 调用后端接口
        const res = await Http.sendMessage({ message });
        if (res.code === 200 && res.analysisResult!=null) {
          that.messageList.push({
            role: 'assistant',
            content: res.analysisResult
          });
        } else {
          that.messageList.push({
            role: 'assistant',
            content: res.msg || '抱歉，我暂时无法回答你的问题'
          });
        }
      } catch (error) {
        console.error('发送失败：', error);
        that.messageList.push({
          role: 'assistant',
          content: '请求失败，请检查网络或联系管理员'
        });
      } finally {
        that.loading = false;
      }

      // 获取div元素
      var divElement = document.getElementById('chat-content');
      divElement.scrollTop = divElement.scrollHeight;
    }
  },
  created() {

  }
}
</script>

<style lang="scss" scoped>
.top-nav {
  display: flex;
  background-color: #fff;
  padding-right: 20px;
  align-items: center;

  .logo {
    display: table-cell;
    width: 256px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    vertical-align: middle;
    background-color: #fff;
    color: #fff;

    img {
      vertical-align: middle;
      height: 90%;
    }
  }

  .nav {
    /*width:calc(100vw - 256px);*/
    /*display: flex;*/
    /*justify-content: space-between;*/
    /*align-items: center;*/
    flex: 1;
    text-align: right;
    font-size: 14px;
  }
}

.doubao-chat-container {
  height: 500px;
  margin: 0px auto;
  display: flex;
  flex-direction: column;
}

.chat-header {
  padding: 16px;
  background-color: #f9fafb;
}

.chat-header h2 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.chat-content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  background-color: #fff;
}

.message-item {
  display: flex;
  margin-bottom: 20px;
  align-items: flex-start;
}

.message-item.user {
  flex-direction: row-reverse;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
}

.message-item.user .avatar {
  margin-left: 10px;
}

.message-item.assistant .avatar {
  margin-right: 10px;
}

.content {
  max-width: 70%;
  padding: 10px 16px;
  border-radius: 18px;
  line-height: 1.5;
  font-size: 14px;
}

.message-item.user .content {
  background-color: #007bff;
  color: #fff;
}

.message-item.assistant .content {
  background-color: #f3f4f6;
  color: #333;
}

.loading {
  display: flex;
}

.loading-dot {
  animation: blink 1s infinite;
  margin-left: 4px;
}

.loading-dot:nth-child(2) {
  animation-delay: 0.2s;
}

.loading-dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes blink {

  0%,
  100% {
    opacity: 0.3;
  }

  50% {
    opacity: 1;
  }
}

.chat-input {
  padding: 16px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  gap: 10px;
}

.input-area {
  flex: 1;
  padding: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  resize: none;
  outline: none;
  font-size: 14px;
  min-height: 40px;
  max-height: 120px;
}

.send-btn {
  padding: 0 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.send-btn:disabled {
  background-color: #94a3b8;
  cursor: not-allowed;
}
</style>
